import { Card } from "@mui/material";
import { Table as TanStackTable } from "@tanstack/react-table";
import React, { useMemo } from "react";
import { Table, TableSkeleton } from "src/components";
import { FormSubmissionsReportRowDto } from "src/http";
import { columnsConfig } from "../utilities";

interface Props {
  isLoading: boolean;
  data: FormSubmissionsReportRowDto[] | undefined;
  selectedTeamGuids: string[];
}

const EmployeeFeedbackTable = React.forwardRef<TanStackTable<FormSubmissionsReportRowDto>, Props>((props, ref) => {
  const columns = useMemo(() => columnsConfig(props.selectedTeamGuids), [props.selectedTeamGuids]);

  return (
    <Card>
      {props.isLoading || props.data === undefined ? (
        <TableSkeleton />
      ) : (
        <Table
          ref={ref}
          tableId="employee-feedback-table"
          data={props.data}
          columns={columns}
          sorting={[
            {
              id: "Person",
              desc: false,
            },
          ]}
          pagination
        />
      )}
    </Card>
  );
});

export { EmployeeFeedbackTable };
